{
    "Accessibility menu": "アクセシビリティメニュー",
    "Close": "閉じる",
    "Content adjustments": "コンテンツ調整",
    "Navigation adjustments": "ナビゲーション調整",
    "Text Align": "テキストの配置",
    "Align Left": "左揃え",
    "Align Center": "中央揃え",
    "Align Right": "右揃え",
    "Adjust Font Size": "フォントサイズ調整",
    "Highlight Title": "タイトルを強調",
    "Highlight Links": "リンクを強調",
    "Readable Font": "読みやすいフォント",
    "Colour adjustments": "色調整",
    "Dark Contrast": "暗いコントラスト",
    "Light Contrast": "明るいコントラスト",
    "High Contrast": "高コントラスト",
    "High Saturation": "高彩度",
    "Low Saturation": "低彩度",
    "Monochrome": "モノクロ",
    "Tools": "ツール",
    "Reading Guide": "リーディングガイド",
    "Big Cursor": "大きなカーソル",
    "Increase Font Size": "フォントサイズ拡大",
    "Decrease Font Size": "フォントサイズ縮小",
    "Letter Spacing": "文字間隔",
    "Line Height": "行の高さ",
    "Font Weight": "フォントの太さ",
    "Dyslexia Font": "ディスレクシア用フォント",
    "Language": "言語",
    "Accessibility widget": "アクセシビリティメニューを開く",
    "Accessibility Profiles": "アクセシビリティプロファイル",
    "Cognitive Disability": "認知障害",
    "Seizure Safe": "発作安全",
    "Accessibility statement": "アクセシビリティステートメント",
    "ADHD": "ADHD",
    "Low Vision": "ロービジョン",
    "Pause Animations": "アニメーション停止",
    "Animation paused": "アニメーションを一時停止しました",
    "Reset all settings": "設定をリセット",
    "Shortcut:": "ショートカット:",
    "Epilepsy Safe Mode": "てんかん安全モード",
    "Mute sounds": "音声をミュート",
    "Page read": "ページ読み上げ",
    "Page read controls": "読み上げコントロール",
    "Pause": "一時停止",
    "Resume": "再開",
    "Stop": "停止",
    "Settings": "設定",
    "Speed": "速度",
    "Voice": "音声",
    "Close accessibility menu": "アクセシビリティメニューを閉じる",
    "Back to accessibility menu": "アクセシビリティメニューに戻る",
    "Search languages": "言語を検索",
    "Selected language": "選択中の言語",
    "View accessibility statement (opens in new window)": "アクセシビリティに関する声明を表示（新しいウィンドウで開きます）",
    "Visit CookieYes website (opens in new window)": "CookieYes のウェブサイトにアクセス（新しいウィンドウで開きます）",
    "Reset all accessibility settings to default": "すべてのアクセシビリティ設定を初期状態に戻す"
}
